import {
    buildListParams,
    getListData,
    handleListIconMouseEnter,
    handleListIconMouseLeave,
    listStyles
} from 'lib/listUtils';
import {
    AppBar,
    Box,
    Button,
    CardContent,
    Checkbox,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControlLabel,
    Tab,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Tabs,
    TextField,
    Tooltip,
    Typography
} from '@material-ui/core';
import theme from 'theme';
import { ANAO } from 'consts';
import api from 'services/api';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { AlertInformation } from 'components';
import { safeSetState } from 'lib/reactUtils';
import { FormActions } from 'views/Components';
import { getApiErrorMessage } from 'lib/formUtils';
import { BackspaceOutlined, Search } from '@material-ui/icons';
import { MODULO_POR_PREFIXO_ROTA, PERMISSIONS_CATALOG } from 'permissionsCatalog';

function TabContainer(props) {
    return (
        <Typography component="div">
            {props.children}
        </Typography>
    );
};

TabContainer.propTypes = {
    children: PropTypes.node.isRequired
};

class PermissoesForm extends Component {
    handleIconMouseEnter = handleListIconMouseEnter;
    handleIconMouseLeave = handleListIconMouseLeave;
    safeSetState = safeSetState;

    _isMounted = false;

    state = {
        catalogo: [],
        permissoesMarcadas: new Set(),
        activeTab: 0,
        isLoading: true,
        isSaving: false,
        openAlert: false,
        messageAlert: '',
        openCopiarModal: false,
        usuariosCopia: [],
        buscaCopia: '',
        codusuarioCopiaSelecionado: null
    };

    /* Carrega as permissões do usuário no módulo atual */
    async componentDidMount() {
        this._isMounted = true;

        const { location } = this.props;

        if (this.isDraftMode()) {
            const rascunho = location?.state?.permissoesRascunho || [];
            const codmodulo = this.getModuloAtivo();
            const catalogo = PERMISSIONS_CATALOG[codmodulo] || [];

            this.safeSetState({
                catalogo,
                permissoesMarcadas: new Set(rascunho),
                isLoading: false
            });

            return;
        }

        await this.loadPermissoes();
    };

    /* Limpa a flag de montagem ao sair da tela */
    componentWillUnmount() {
        this._isMounted = false;
    };

    /* Indica se é um rascunho de usuário ainda não salvo */
    isDraftMode = () => this.getCodUsuario() === 'novo';

    /* Retorna o código do módulo ativo a partir do caminho da rota */
    getModuloAtivo = () => {
        const prefixo = this.props.match?.path?.split('/')[1] || '';

        return MODULO_POR_PREFIXO_ROTA[prefixo];
    };

    /* Retorna o código do usuário sendo editado */
    getCodUsuario = () => this.props.match?.params?.id;

    /* Retorna o caminho de volta para o UsuarioForm */
    getBasePathUsuario = () => {
        const path = this.props.match?.path || '';

        return path.replace('/:id/permissoes', '');
    };

    /* Retorna o caminho do formulário de usuário em criação */
    getPathUsuarioNovo = () => `${this.getBasePathUsuario()}/novo`;

    /* Volta para o UsuarioForm levando o rascunho de usuário e permissões */
    backToUsuarioForm = (permissoesMarcadas) => {
        const { history } = this.props;
        const { confirmPwd, usuario } = this.props.location?.state || {};

        history.push({
            pathname: this.getPathUsuarioNovo(),
            state: {
                usuario,
                confirmPwd,
                permissoesRascunho: [...permissoesMarcadas]
            }
        });
    };

    /* Carrega as permissões marcadas do usuário */
    loadPermissoes = async () => {
        const codmodulo = this.getModuloAtivo();
        const catalogo = PERMISSIONS_CATALOG[codmodulo] || [];

        if (!codmodulo) {
            this.handleOpenAlert('Módulo não reconhecido para permissões!');

            this.safeSetState({
                catalogo,
                isLoading: false
            });

            return;
        }

        try {
            const response = await api.get(`/usuario/permissoes/${this.getCodUsuario()}`, {
                params: { codmodulo }
            });

            const permissoes = response?.data?.permissions || [];

            this.safeSetState({
                catalogo,
                permissoesMarcadas: new Set(permissoes),
                isLoading: false
            });
        } catch (error) {
            console.error('Erro ao carregar as permissões:', error.response?.data || error.message);

            this.handleOpenAlert(getApiErrorMessage(error, 'Erro ao carregar as permissões!'));

            this.safeSetState({
                catalogo,
                isLoading: false
            });
        }
    };

    /* Troca a aba superior */
    handleTabChange = (event, newValue) => {
        this.setState({ activeTab: newValue });
    };

    /* Marca ou desmarca uma permissão */
    onChangeCheckbox = (permCode) => {
        this.setState(prevState => {
            const permissoesMarcadas = new Set(prevState.permissoesMarcadas);

            if (permissoesMarcadas.has(permCode)) {
                permissoesMarcadas.delete(permCode);
            } else {
                permissoesMarcadas.add(permCode);
            }

            return { permissoesMarcadas };
        });
    };

    /* Marca todas as permissões da aba atual */
    handleMarcarTodas = () => {
        const { activeTab, catalogo } = this.state;
        const aba = catalogo[activeTab];

        if (!aba) return;

        this.setState(prevState => {
            const permissoesMarcadas = new Set(prevState.permissoesMarcadas);

            aba.grupos.forEach(grupo => {
                grupo.itens.forEach(item => permissoesMarcadas.add(item.permCode));
            });

            return { permissoesMarcadas };
        });
    };

    /* Desmarca todas as permissões da aba atual */
    handleDesmarcarTodas = () => {
        const { activeTab, catalogo } = this.state;
        const aba = catalogo[activeTab];

        if (!aba) return;

        this.setState(prevState => {
            const permissoesMarcadas = new Set(prevState.permissoesMarcadas);

            aba.grupos.forEach(grupo => {
                grupo.itens.forEach(item => permissoesMarcadas.delete(item.permCode));
            });

            return { permissoesMarcadas };
        });
    };

    /* Abre a janela de alerta com mensagem */
    handleOpenAlert = (message) => {
        this.setState({
            openAlert: true,
            messageAlert: message
        });
    };

    /* Fecha a janela de alerta */
    handleCloseAlert = () => {
        this.setState({ openAlert: false });
    };

    /* Clicar para salvar */
    onClickSave = async () => {
        const { history } = this.props;
        const { permissoesMarcadas } = this.state;

        if (this.isDraftMode()) {
            this.backToUsuarioForm(permissoesMarcadas);

            return;
        }

        const codmodulo = this.getModuloAtivo();

        this.setState({ isSaving: true });

        try {
            await api.put(`/usuario/permissoes/${this.getCodUsuario()}`, {
                codmodulo,
                permissions: [...permissoesMarcadas]
            });

            history.push(`${this.getBasePathUsuario()}/${this.getCodUsuario()}`);
        } catch (error) {
            console.error('Erro ao salvar as permissões:', error.response?.data || error.message);

            this.handleOpenAlert(getApiErrorMessage(error, 'Erro ao salvar as permissões!'));

            this.setState({ isSaving: false });
        }
    };

    /* Clicar para cancelar */
    onClickCancel = () => {
        const { history, location } = this.props;

        if (this.isDraftMode()) {
            const rascunhoOriginal = location?.state?.permissoesRascunho || [];

            this.backToUsuarioForm(new Set(rascunhoOriginal));

            return;
        }

        history.push(`${this.getBasePathUsuario()}/${this.getCodUsuario()}`);
    };

    /* Abre o modal de cópia de permissões */
    handleOpenCopiarModal = () => {
        this.setState({
            openCopiarModal: true,
            usuariosCopia: [],
            buscaCopia: '',
            codusuarioCopiaSelecionado: null
        });

        this.loadUsuariosCopia();
    };

    /* Fecha o modal de cópia de permissões */
    handleCloseCopiarModal = () => {
        this.setState({ openCopiarModal: false });
    };

    /* Carrega os usuários disponíveis para cópia */
    loadUsuariosCopia = async () => {
        const { buscaCopia } = this.state;

        const params = buildListParams({
            page: 0,
            rowsPerPage: 50,
            filters: [
                {
                    field: 'USUARIO',
                    value: buscaCopia,
                    operator: '_like_'
                },
                {
                    field: 'INATIVO',
                    value: ANAO
                }
            ]
        });

        try {
            const response = await api.get('/usuario' + params);

            const usuariosCopia = getListData(response).filter(
                item => String(item.codusuario) !== String(this.getCodUsuario())
            );

            this.safeSetState({ usuariosCopia });
        } catch (error) {
            console.error('Erro ao carregar usuários para cópia:', error.response?.data || error.message);

            this.safeSetState({ usuariosCopia: [] });
        }
    };

    /* Altera o texto de busca do modal de cópia */
    onChangeBuscaCopia = (event) => {
        this.setState({ buscaCopia: event.target.value.toUpperCase() });
    };

    /* Limpa a busca do modal de cópia e recarrega a lista */
    limpaBuscaCopia = () => {
        this.setState(
            { buscaCopia: '' },
            this.loadUsuariosCopia
        );
    };

    /* Seleciona o usuário do qual copiar as permissões */
    onSelectUsuarioCopia = (codusuario) => {
        this.setState({ codusuarioCopiaSelecionado: codusuario });
    };

    /* Confirma a cópia das permissões do usuário selecionado */
    onConfirmarCopiarPermissoes = async () => {
        const { codusuarioCopiaSelecionado } = this.state;

        if (!codusuarioCopiaSelecionado) return;

        const codmodulo = this.getModuloAtivo();

        try {
            const response = await api.get(`/usuario/permissoes/${codusuarioCopiaSelecionado}`, {
                params: { codmodulo }
            });

            const permissoes = response?.data?.permissions || [];

            this.safeSetState({
                permissoesMarcadas: new Set(permissoes),
                openCopiarModal: false
            });
        } catch (error) {
            console.error('Erro ao copiar as permissões:', error.response?.data || error.message);

            this.handleOpenAlert(getApiErrorMessage(error, 'Erro ao copiar as permissões!'));

            this.safeSetState({ openCopiarModal: false });
        }
    };

    render() {
        const {
            activeTab,
            buscaCopia,
            catalogo,
            codusuarioCopiaSelecionado,
            isLoading,
            isSaving,
            messageAlert,
            openAlert,
            openCopiarModal,
            permissoesMarcadas,
            usuariosCopia
        } = this.state;

        const { actionIcon, iconGroup } = listStyles;

        if (isLoading) {
            return (
                <div>
                    <CardContent>
                        <Typography variant="body1">
                            Carregando permissões...
                        </Typography>
                    </CardContent>
                </div>
            );
        }

        const aba = catalogo[activeTab];

        return (
            <div>
                <AppBar
                    position="static"
                    color="default"
                >
                    <Tabs
                        value={activeTab}
                        onChange={this.handleTabChange}
                        indicatorColor="primary"
                        textColor="primary"
                        variant="scrollable"
                        scrollButtons="auto"
                    >
                        {catalogo.map(item => (
                            <Tab
                                key={item.aba}
                                label={item.aba}
                            />
                        ))}
                    </Tabs>
                </AppBar>

                <CardContent>
                    <Typography
                        component="h1"
                        variant="h3"
                    >
                        Permissões
                    </Typography>

                    <Box
                        display="flex"
                        justifyContent="space-between"
                        flexWrap="wrap"
                        style={{
                            gap: 10,
                            margin: '16px 0'
                        }}
                    >
                        <Box
                            display="flex"
                            style={{ gap: 10 }}
                        >
                            <Button
                                variant="contained"
                                onClick={this.handleMarcarTodas}
                                style={{ textTransform: 'none' }}
                            >
                                Marcar todas
                            </Button>

                            <Button
                                variant="contained"
                                onClick={this.handleDesmarcarTodas}
                                style={{ textTransform: 'none' }}
                            >
                                Desmarcar todas
                            </Button>
                        </Box>

                        <Box
                            display="flex"
                            style={{ gap: 10 }}
                        >
                            <Button
                                variant="contained"
                                onClick={this.handleOpenCopiarModal}
                                style={{
                                    textTransform: 'none',
                                    backgroundColor: theme.palette.grey[200],
                                    color: theme.palette.primary.main,
                                    border: `1px solid ${theme.palette.primary.main}`
                                }}
                            >
                                Copiar permissões
                            </Button>

                            <FormActions
                                onSave={this.onClickSave}
                                onCancel={this.onClickCancel}
                                disableSave={isSaving}
                            />
                        </Box>
                    </Box>

                    <br />

                    <TabContainer>
                        {aba?.grupos.map((grupo, index) => (
                            <Box
                                key={grupo.grupo || `grupo-${index}`}
                                style={{ marginBottom: 20 }}
                            >
                                {grupo.grupo && (
                                    <Typography
                                        variant="subtitle1"
                                        style={{
                                            fontWeight: 600,
                                            marginBottom: 4
                                        }}
                                    >
                                        {grupo.grupo}
                                    </Typography>
                                )}

                                <Box
                                    display="flex"
                                    flexDirection="column"
                                >
                                    {grupo.itens.map(item => (
                                        <FormControlLabel
                                            key={item.permCode}
                                            label={item.label}
                                            control={
                                                <Checkbox
                                                    checked={permissoesMarcadas.has(item.permCode)}
                                                    onChange={() => this.onChangeCheckbox(item.permCode)}
                                                    color="primary"
                                                />
                                            }
                                        />
                                    ))}
                                </Box>
                            </Box>
                        ))}
                    </TabContainer>
                </CardContent>

                <AlertInformation
                    open={openAlert}
                    message={messageAlert}
                    handleClose={this.handleCloseAlert}
                />

                <Dialog
                    open={openCopiarModal}
                    onClose={this.handleCloseCopiarModal}
                    fullWidth
                    maxWidth="sm"
                    disableRestoreFocus
                >
                    <DialogTitle>
                        Copiar permissões
                    </DialogTitle>

                    <DialogContent style={{ paddingBottom: 24 }}>
                        <Box
                            display="flex"
                            alignItems="center"
                            style={{
                                gap: 10,
                                marginBottom: 16
                            }}
                        >
                            <TextField
                                label="Buscar usuário"
                                fullWidth
                                value={buscaCopia}
                                onChange={this.onChangeBuscaCopia}
                            />

                            <span style={iconGroup}>
                                <Tooltip title="Procurar">
                                    <Search
                                        onClick={this.loadUsuariosCopia}
                                        onMouseEnter={this.handleIconMouseEnter}
                                        onMouseLeave={this.handleIconMouseLeave}
                                        style={actionIcon}
                                    />
                                </Tooltip>

                                <Tooltip title="Limpar">
                                    <BackspaceOutlined
                                        onClick={this.limpaBuscaCopia}
                                        onMouseEnter={this.handleIconMouseEnter}
                                        onMouseLeave={this.handleIconMouseLeave}
                                        style={actionIcon}
                                    />
                                </Tooltip>
                            </span>
                        </Box>

                        {usuariosCopia.length === 0 && (
                            <Typography
                                variant="body2"
                                align="center"
                            >
                                Nenhum usuário encontrado
                            </Typography>
                        )}

                        {usuariosCopia.length > 0 && (
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell align="center">Código</TableCell>

                                        <TableCell align="center">Usuário</TableCell>
                                    </TableRow>
                                </TableHead>

                                <TableBody>
                                    {usuariosCopia.map(item => (
                                        <TableRow
                                            key={item.codusuario}
                                            hover
                                            onClick={() => this.onSelectUsuarioCopia(item.codusuario)}
                                            style={{
                                                cursor: 'pointer',
                                                backgroundColor: item.codusuario === codusuarioCopiaSelecionado
                                                    ? theme.palette.grey[200] : 'transparent'
                                            }}
                                        >
                                            <TableCell align="center">{item.codusuario}</TableCell>

                                            <TableCell align="center">{item.usuario}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        )}
                    </DialogContent>

                    <DialogActions>
                        <Button
                            color="secondary"
                            variant="contained"
                            onClick={this.handleCloseCopiarModal}
                        >
                            Cancelar
                        </Button>

                        <Button
                            color="primary"
                            variant="contained"
                            disabled={!codusuarioCopiaSelecionado}
                            onClick={this.onConfirmarCopiarPermissoes}
                        >
                            Confirmar
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
        );
    }
};

PermissoesForm.propTypes = {
    history: PropTypes.object,
    match: PropTypes.object,
    location: PropTypes.object,
};

export default PermissoesForm;